import CityPageTemplate from "../city-template/CityPageTemplate";
import { losAlamosConfig } from "./data";

export default function LosAlamosPage() {
  return <CityPageTemplate config={losAlamosConfig} />;
}